import { PeriodicNotificationModel } from "./periodicNotificationModel";

export class PeriodicNotificationIncidentModel extends PeriodicNotificationModel {
    incidentStatuses: number[];
    userRoleIDs: number[];
}
